import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import PtsConfirmDialogue from "../ptsAlert/PtsConfirmDialogue";

export class DeleteIconButton extends Component {
  confirmDialogueRef = React.createRef();
  constructor(props) {
    super(props);
    let domainObject = props.domainObject ? props.domainObject : "";
    this.state = {
      domainObject: domainObject,
      title: props.title ? props.title : "Delete Confirmation",
      text: props.text ? props.text : domainObject,
      onClick: props.onClick,
      caption: props.caption,
      pageId: props.pageId,
      hideToolTip: props.hideToolTip,
      btnName: props.btnName,
    };
  }

  deleteConfirmed() {
    if (this.confirmDialogueRef && this.confirmDialogueRef.current) {
      this.confirmDialogueRef.current.setState({ open: false });
    }
    if (this.state.onClick) {
      this.state.onClick();
    }
  }

  onClick() {
    if (
      this.confirmDialogueRef &&
      this.confirmDialogueRef.current &&
      this.confirmDialogueRef.current.state.open === false
    ) {
      this.confirmDialogueRef.current.handleClickOpen();
    } else {
    }
  }

  getTooltip() {
    if (this.state.pageId === "Group") {
      return "Delete Group";
    } else {
      return "Delete";
    }
  }
  render() {
    this.confirmDialogueRef = React.createRef();
    return (
      <span
        style={{
          cursor: "pointer",
          fontSize: "18px",
          // marginRight: "0.5em",
          // paddingTop: "5px",
          float: "right",
          display: "flex",
        }}
      >
        <PtsConfirmDialogue
          ref={this.confirmDialogueRef}
          title={this.state.title}
          btnName={this.state.btnName}
          text={this.state.text}
          open={false}
          pageId={this.state.pageId}
          confirmCallback={this.deleteConfirmed.bind(this)}
        />
        <Button
          variant="contained"
          style={
            this.state.pageId !== "Event"
              ? {
                background: "#d3d8de",
                color: "#353538",
                // marginRight: "1rem",
                float: "right",
                textTransform: "capitalize",
                padding: "2px 10px",
              }
              : {
                background: "#fff",
                color: "#000",
                fontWeight: "bold",
                // marginRight: "1rem",
                float: "right",
                textTransform: "capitalize",
                padding: "2px 10px",
              }
          }
          startIcon={
            <i
              class="fa-regular fa-trash-can"
              aria-hidden="true"
              style={{ fontSize: "14px", fontWeight: "600" }}
            ></i>
          }
          onClick={this.onClick.bind(this)}
        >
          Delete
        </Button>
      </span>
    );
  }
}
export default DeleteIconButton;
